import { render } from "./Recap.vue?vue&type=template&id=df4b8926&scoped=true"
import script from "./Recap.vue?vue&type=script&lang=js"
export * from "./Recap.vue?vue&type=script&lang=js"

import "./Recap.vue?vue&type=style&index=0&id=df4b8926&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4b8926"]])

export default __exports__